import script from "./OBV.vue?vue&type=script&lang=js"
export * from "./OBV.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__